import Treeview from './view';

export default Treeview;
